import { delistColor, DelistingIcon, delistingReasonAuto, delistingReasonCategory, delistingReasonDeflagged, delistingReasonScrapped, delistingType } from '#delisting/constants';
import { Delisting } from '#delisting/model';
import { TagReference } from 'apprise-core/tag';
import { useT } from 'apprise-frontend-core/intl/language';
import { useForm } from 'apprise-frontend-core/utils/form';
import { TagBox } from 'apprise-frontend-tags/tag/tagbox';
import { Button } from 'apprise-ui/button/button';
import { DateBox } from 'apprise-ui/date/datebox';
import { useValidation } from 'apprise-ui/field/validation';
import { Form } from 'apprise-ui/form/form';
import { RouteGuard } from 'apprise-ui/link/routeguard';
import { TextBox } from 'apprise-ui/textbox/textbox';
import { useAsyncTask } from 'apprise-ui/utils/asynctask';
import { Explainer } from 'apprise-ui/utils/explainer';
import format from 'date-fns/format';
import isAfter from 'date-fns/isAfter';
import { useContext } from 'react';
import { DetailContext } from './context';
import { useEffects } from './effects';
import { editableReasons } from '#delisting/validator';


export const DelistingPanel = () => {

    const t = useT()

    const { delisted, delistingKit, record } = useContext(DetailContext)

    const { Drawer } = delistingKit

    const title = delisted ? t('delisting.form_delisted_title') : t('delisting.form_delist_title')


    const readonly = delisted && !editableReasons.includes(record.delisting!.reason)


    return <Drawer renderOnMount={false} unmountOnClose readonly={readonly} icon={<DelistingIcon />} title={title} width={500}>

        <Inner />

    </Drawer>
}

const Inner = () => {

    const t = useT()

    const { record } = useContext(DetailContext)

    const { delist } = useEffects()

    const form = useForm<Delisting>(record[delistingType] ?? {

        date: new Date().toISOString()

    } as Delisting)

    const task = useAsyncTask()

    const { reportOf, check, is } = useValidation()

    const submitForm = task.make(async () => {

        form.reset.to(form.edited).quietly()

        delist(form.edited)


    })
        .with($ => $.show(t('delisting.form_delisting')))
        .done()

    const fields = reportOf({

        date: {

            label: t("delisting.form_date_lbl"),
            msg: t("delisting.form_date_msg"),
            ...check(is.empty).on(form.edited.date),
        }

        ,

        reason: {

            label: t("delisting.form_reason_lbl"),
            msg: t("delisting.form_reason_msg"),
            help: undefined,
            ...check(is.empty).on(form.edited.reason),
        }

        ,

        note: {

            label: t("delisting.form_note_lbl"),
            msg: t("delisting.form_note_msg")
        }


    });

    const delistBtn = <Button type='primary' enabled={form.dirty} disabled={fields.errors() > 0} onClick={submitForm}>
        {t('delisting.form_btn')}
    </Button>

    const auth = record?.authorization ?? undefined

    const from = new Date(auth.from)
    const to = new Date(auth.to)
    const date = new Date(form.edited.date)

    const patchAuth = form.edited.date && auth && isAfter(to, date)

    const reasonDisabled = (t: TagReference) => t === delistingReasonAuto || (!!record?.delisting && ![delistingReasonDeflagged, delistingReasonScrapped].includes(t))

    return <>

        <RouteGuard when={form.dirty} ignoreQueryParams={false} />

        <Explainer icon={<DelistingIcon color={delistColor} />}>
            {t('delisting.form_explainer')}
        </Explainer>

        <br />

        <Form style={{ padding: '0px 40px', textAlign:'center' }} centered >

            <DateBox info={fields.date} onChange={form.set.with((m, v) => m.date = v!)}>
                {form.edited.date}
            </DateBox>

            <div className='delist-authz-notice'>
                {patchAuth &&

                    t('delisting.auth_correction_msg',
                        {
                            from: format(from, 'P'),
                            to: format(to, 'P'),
                            newto: format(date, 'P')
                        }
                    )}
            </div>

            <TagBox style={{padding:"0px 40px"}} info={fields.reason} help={undefined} noClear category={delistingReasonCategory} disabledOf={reasonDisabled} onChange={form.set.with((m, v) => m.reason = v!)}>
                {form.edited.reason}
            </TagBox>

            <TextBox info={fields.note} multi={{ start: 4, end: 8 }} onChange={form.set.with((m, v) => m.note = v)}>
                {form.edited.note}
            </TextBox>

            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: 25 }}>
                {delistBtn}
            </div>

        </Form>


    </>


}